// eslint-disable-next-line import/no-named-as-default
import Icon from "@mdi/react";
import { useState } from "react";

import { mdiCog } from "@mdi/js";
import { Popover } from "antd";

import { ThreeDViewerOptionT } from "models";

import { ToolbarButton } from "components/base";

import ThreeDVSettingsOptions from "./ThreeDVSettingsOptions";

function ThreeDVSettingsToggle(options: ThreeDViewerOptionT) {
  const [visible, setVisible] = useState(false);

  return (
    <Popover
      content={<ThreeDVSettingsOptions {...options} />}
      trigger="click"
      placement="bottomRight"
      open={visible}
      onOpenChange={(v) => setVisible(v)}>
      <ToolbarButton
        icon={<Icon path={mdiCog} size={1.5} />}
        isMenuButton={true}
        active={false}
        tooltipText={"3DV Settings"}
        overflowLabel={"Settings"}
        styleKey="threeDVToolbar"
      />
    </Popover>
  );
}

export default ThreeDVSettingsToggle;
